// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  /* sync with NAVBAR_HEIGHT in common.ts */
  --header-height: 64px;
  --sidebar-width-full: 200px;
  --sidebar-width-collapsed: 80px;
  --content-padding-v: 32px;
  --content-padding-h: 64px;
  --content-max-width: 1400px;
  --content-scoped-title-height: 50px;
  --content-scoped-title-margin-bottom: 24px;
  /* 90% opacity white */
  --white-90: rgba(255, 255, 255, 0.9);
  /* 80% opacity white */
  --white-80: rgba(255, 255, 255, 0.8);
  /* 70% opacity white */
  --white-70: rgba(255, 255, 255, 0.7);
  /* 90% opacity black */
  --black-90: rgba(0, 0, 0, 0.9);
  --antd-blue-5: #1677ff;
}
.range-separator {
  display: flex;
  align-items: center;
  padding: 0 8px;
  border-top: 1px solid #d9d9d9;
  border-bottom: 1px solid #d9d9d9;
  background: #fafafa;
  user-select: none;
}
html,
body {
  min-height: 100%;
  background-color: #f5f5f5;
  margin: 0;
}
/* BEGIN utility classes */
.no-margin-top {
  margin-top: 0 !important;
}
/* Name compatible with tailwind if needed */
.w-full {
  width: 100%;
}
.h-full {
  height: 100%;
}
.h-auto {
  height: auto;
}
.m-0 {
  margin: 0;
}
.mb-0,
.ant-typography.mb-0 {
  margin-bottom: 0;
}
.p-0 {
  padding: 0;
}
.flex-1 {
  flex: 1;
}
.float-right {
  float: right;
}
.position-absolute {
  position: absolute;
}
.position-relative {
  position: relative;
}
.block {
  display: block;
}
.none {
  display: none;
}
.rounded-lg {
  border-radius: 8px;
}
/* also consistent with --ant-border-radius-lg */
.rounded-xl {
  border-radius: 12px;
}
.rounded-e-none {
  border-start-end-radius: 0;
  border-end-end-radius: 0;
}
.opacity-50 {
  opacity: 0.5;
}
.list-none {
  list-style-type: none;
}
.cursor-pointer {
  cursor: pointer;
}
.select-none {
  user-select: none;
}
.font-mono {
  font-family: ui-monospace, monospace;
}
.text-base {
  font-size: 1rem;
}
.text-center {
  text-align: center;
}
.underline,
a.underline {
  text-decoration-line: underline;
}
.decoration-dotted {
  text-decoration-style: dotted;
}
.italic {
  font-style: italic;
}
/* custom, tailwind-esque */
.max-w-half-cmw {
  max-width: calc(var(--content-max-width) / 2);
}
.shadow {
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
}
.float-btn-pos {
  /* For normal computer screens */
  bottom: 3em;
  right: 5em;
}
:not(.ant-float-btn-group).float-btn-pos {
  scale: 125%;
}
.ant-float-btn-group.float-btn-pos {
  /* For normal screens, increase float button group gap size */
  gap: 24px;
}
.ant-float-btn-group.float-btn-pos .ant-float-btn {
  scale: 125%;
}
/* TODO: antd 6.x: gray-6 */
.antd-gray-7 {
  color: #8c8c8c;
}
.error-text {
  color: #f5222d;
  /* https://ant.design/docs/spec/colors red-6 */
}
.visually-hidden {
  /*
  For accessibility; visually hidden but available to screen readers. Taken from Bootstrap.

  The MIT License (MIT)

  Copyright (c) 2011-2026 The Bootstrap Authors

  Permission is hereby granted, free of charge, to any person obtaining a copy
  of this software and associated documentation files (the "Software"), to deal
  in the Software without restriction, including without limitation the rights
  to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
  copies of the Software, and to permit persons to whom the Software is
  furnished to do so, subject to the following conditions:

  The above copyright notice and this permission notice shall be included in
  all copies or substantial portions of the Software.

  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
  IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
  FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
  AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
  LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
  OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
  THE SOFTWARE.
  */
  width: 1px !important;
  height: 1px !important;
  padding: 0 !important;
  margin: -1px !important;
  overflow: hidden !important;
  clip: rect(0, 0, 0, 0) !important;
  white-space: nowrap !important;
  border: 0 !important;
}
/* END utility classes */
.select-dataset-item {
  transition: all 0.2s;
  border-radius: 8px;
  /* Consistent with --ant-border-radius-lg */
  cursor: pointer;
}
.select-dataset-item .ant-avatar {
  background-color: #8c8c8c;
}
.select-dataset-item:hover {
  background-color: #e6f4ff;
}
.select-dataset-item:hover .ant-avatar {
  color: #e6f4ff;
}
.select-dataset-item.selected,
.select-dataset-item.selected:hover {
  background-color: #91caff;
}
.select-dataset-item.selected .ant-avatar {
  background-color: #0958d9;
  color: #91caff;
}
.ant-tag.filters-applied-tag {
  transition: max-width 0.2s, padding 0.2s, border-width 0.2s, opacity 0.2s, margin-left 0.2s;
  height: 22px;
  vertical-align: top;
  margin-top: 2px;
  text-wrap: nowrap;
  overflow: hidden;
  box-sizing: border-box;
  /* overridden by has-filters class when we have filters applied: */
  max-width: 0;
  padding: 0;
  border-width: 0;
  margin-left: 1px;
}
.ant-tag.filters-applied-tag.has-filters {
  max-width: 150px;
  padding: 0 7px;
  border-width: 1px;
  margin-left: 1em;
}
.scoped-title {
  position: sticky;
  top: -3px;
  left: 0;
  right: 0;
  z-index: 20;
  box-sizing: border-box;
  height: var(--content-scoped-title-height);
  margin-bottom: var(--content-scoped-title-margin-bottom);
  padding-top: 3px;
  margin-left: calc(-1 * var(--content-padding-h));
  margin-right: calc(-1 * var(--content-padding-h));
  padding-left: max(calc((100% - var(--content-max-width)) / 2 + var(--content-padding-h)), var(--content-padding-h));
  padding-right: max(calc((100% - var(--content-max-width)) / 2 + var(--content-padding-h)), var(--content-padding-h));
  background-color: rgba(245, 245, 245, 0.8);
  border-bottom: 1px solid rgba(240, 240, 240, 0);
  /* invisible border to transition from/to */
  backdrop-filter: blur(10px);
  transition: border-bottom-color 0.5s ease-in-out, margin 0.5s ease-in-out, padding 0.5s ease-in-out, height 0.5s ease-in-out, box-shadow 0.1s ease-in-out, opacity 0.5s ease-in-out;
}
.scoped-title .filters-applied-tag {
  opacity: 0;
}
.scoped-title__back {
  margin-right: 12px;
  font-size: 1.8rem;
  color: rgba(0, 0, 0, 0.45);
}
.scoped-title__breadcrumb {
  font-size: 1.8rem;
  transition: font-size 0.3s ease-in-out;
}
.scoped-title__breadcrumb .anticon {
  font-size: 0.9em;
}
.scoped-title__breadcrumb .ant-breadcrumb-item a {
  height: 3rem;
}
.scoped-title[data-stuck] {
  height: 50px;
  border-bottom: 1px solid #ebebeb;
  box-shadow: 0 1px 5px rgba(0, 0, 0, 0.02);
}
.scoped-title[data-stuck] .filters-applied-tag {
  opacity: 1;
}
.scoped-title[data-stuck] .scoped-title__back {
  width: 32px;
  min-width: 32px;
  height: 32px;
  font-size: 1.2rem;
}
.scoped-title[data-stuck] .scoped-title__breadcrumb {
  font-size: 1.2rem;
  line-height: 46px;
}
.scoped-title[data-stuck] .scoped-title__breadcrumb a {
  height: 38px;
  margin-top: 4px;
  line-height: 38px;
}
/* BEGIN react18-json-view styling */
.json-view {
  color: #002b36;
  --json-property: #002b36;
  --json-index: #6c71c4;
  --json-number: #268bd2;
  --json-string: #cb4b16;
  --json-boolean: #2aa198;
  --json-null: #dc322f;
}
/* END react18-json-view styling */
/* BEGIN layout HTML styling */
#default-layout {
  --sidebar-width: var(--sidebar-width-full);
  min-height: 100vh;
}
#default-layout.sidebar-collapsed {
  --sidebar-width: var(--sidebar-width-collapsed);
}
#site-header {
  position: fixed;
  height: var(--header-height);
  width: 100%;
  z-index: 100;
  top: 0;
  /* Header padding is reduced to 24px to provide more breathing room for buttons at small screen sizes and grid-align
     logo with sidebar icons. */
  padding: 0 24px;
}
#site-header h1.ant-typography {
  margin: 0;
  font-size: 1.5em;
  line-height: var(--header-height);
}
#site-header.light h1.ant-typography {
  color: var(--black-90);
}
#site-header.dark h1.ant-typography {
  color: var(--white-90);
}
#site-sider {
  position: fixed;
  left: 0;
  top: var(--header-height);
  z-index: 100;
  border-right: 1px solid #f0f0f0;
  overflow: auto;
  height: calc(100vh - var(--header-height));
  transition: transform 0.3s;
}
#default-layout.sidebar-hidden #site-sider {
  overflow: hidden;
  transform: translate(calc(-1 * var(--sidebar-width)), 0);
}
.ant-layout-sider-trigger {
  border-right: 1px solid #f0f0f0;
}
#content-layout {
  position: fixed;
  top: var(--header-height);
  left: var(--sidebar-width);
  right: 0;
  bottom: 0;
  display: block;
  width: calc(100% - var(--sidebar-width));
  overflow: auto;
  transition: left 0.3s, width 0.3s;
}
#default-layout.sidebar-hidden #content-layout {
  left: 0;
  width: 100%;
}
#content-layout > .ant-layout-content {
  padding: var(--content-padding-v) var(--content-padding-h);
}
.margin-auto {
  margin: auto;
}
.container {
  width: 100%;
  max-width: var(--content-max-width);
}
/* END layout HTML styling */
#dashboard-tabs {
  margin: 0 12px;
}
#dashboard-tabs.ant-tabs-card > .ant-tabs-nav .ant-tabs-tab {
  /* by default, antd card-style tab borders are too subtle. make them "pop" a bit more :-) */
}
#dashboard-tabs.ant-tabs-card > .ant-tabs-nav .ant-tabs-tab:not(.ant-tabs-tab-active) {
  /* by default, antd card-style unselected tabs are too subtle. make them "pop" a bit more :-) */
  border: 1px solid #e9e9e9;
  background: rgba(0, 0, 0, 0.03);
}
/* BEGIN about HTML styling */
/* Elements which are the first child of the about content container shouldn't have the default top margin */
.about-content *:first-child {
  margin-top: 0;
}
/* Elements which are the last child of the about content container shouldn't have the default bottom margin */
.about-content *:last-child {
  margin-bottom: 0;
}
/* Images should scale proportionally with container width */
.about-content img {
  max-width: 100%;
  height: auto;
}
/* END about HTML styling */
/* BEGIN overview */
.count-card {
  min-width: 150px;
  transition: height 0.3s ease-in-out, margin-bottom 0.3s ease-in-out, box-shadow 0.15s ease-in-out, opacity 0.15s ease-in-out;
}
.count-card .ant-statistic .ant-statistic-content {
  white-space: nowrap;
}
.count-card.shadow {
  border-color: #e9e9e9;
  /* a bit darker to contrast against box-shadow */
}
.count-card.shadow.count-card-clickable {
  cursor: pointer;
  opacity: 0.9;
}
.count-card.shadow.count-card-clickable:hover {
  box-shadow: 0 3px 15px rgba(0, 0, 0, 0.1);
  opacity: 1;
}
.count-card.shadow.count-card-clickable .counts-title {
  text-decoration: underline;
  transition: color 0.15s ease-in-out;
}
.count-card.shadow.count-card-clickable:hover .counts-title,
.count-card.shadow.count-card-clickable:hover .count-card__show-hide {
  color: #1677ff;
}
.count-card.shadow.count-card-selected {
  border-bottom: none;
  z-index: 3;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  margin-bottom: -12px;
}
.counts-title__text {
  white-space: nowrap;
}
.count-card__show-hide {
  position: absolute;
  left: 0;
  z-index: 4;
  height: 32px;
  width: 100%;
  text-align: center;
  font-size: 12px;
  transition: bottom 0.3s ease-in-out;
}
.count-card__show-hide:hover {
  color: #1677ff;
}
.dataset-provenance-card-grid {
  --dataset-grid-gap: 20px;
  display: grid;
  /* 690 * 2 + 20 (gap) = 1400 */
  grid-template-columns: repeat(auto-fit, minmax(250px, calc((var(--content-max-width) - var(--dataset-grid-gap)) / 2)));
  gap: var(--dataset-grid-gap);
}
.slick-arrow {
  color: black !important;
  /* override slick-next/slick-prev color */
}
.slick-dots li button {
  background-color: black !important;
  /* override slick-dots color */
}
.overview {
  transition: opacity 0.2s ease-in-out;
}
.overview.loading {
  opacity: 0.2;
}
/* END overview */
/* BEGIN search */
.search-sub-form {
  flex: 1;
}
h3.search-sub-form-title {
  font-size: 1.1rem;
  margin-top: 0;
}
.search-results-pane {
  display: flex;
  justify-content: center;
  width: 100%;
}
.search-result-statistic.enabled {
  padding: 8px 16px;
  margin-left: -16px;
  border-radius: 8px;
  /* Consistent with --ant-border-radius-lg */
  cursor: pointer;
  border: 1px solid #d9d9d9;
  box-shadow: 0 2px 0 rgba(0, 0, 0, 0.02);
  transition: all 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  /* from antd */
}
.search-result-statistic.enabled:hover {
  border-color: #4096ff;
}
.search-result-statistic.selected {
  background-color: #fafafa;
}
.search-result-statistic.enabled.selected {
  box-shadow: 0 2px 0 rgba(0, 0, 0, 0.02), inset 0 2px 5px rgba(0, 0, 0, 0.08);
}
.ant-table-wrapper .ant-table.ant-table-empty .ant-table-tbody > tr.ant-table-placeholder {
  /* patch for ant background clip issue in empty tables with no headers */
  background: none;
}
/* END search */
/* BEGIN phenopackets/other clinical+phenotypic metadata views */
.fixed-item-label-width .ant-descriptions-item-label {
  /* Align split line vertically in all descriptions */
  width: min(30vw, 250px);
}
.fixed-item-label-width-narrow .ant-descriptions-item-label {
  /* Align split line vertically in all descriptions */
  width: min(15vw, 125px);
}
.fixed-item-label-width-very-narrow .ant-descriptions-item-label {
  /* Align split line vertically in all descriptions */
  width: min(15vw, 80px);
}
tr.ant-table-expanded-row .ant-descriptions-item-content .ant-descriptions > .ant-descriptions-view > table {
  width: auto;
}
/*  - compact descriptions and table */
.ant-descriptions.compact .ant-descriptions-row > td {
  padding-bottom: 2px;
}
.ant-descriptions.compact .ant-descriptions-item-content,
.ant-descriptions.compact .ant-descriptions-item-label {
  padding: 2px 12px !important;
}
.ant-descriptions-item-content .ant-descriptions.compact:not(.ant-descriptions-bordered) .ant-descriptions-item-label {
  /* nested non-bordered description items - kill horizontal padding */
  padding: 2px 0 !important;
}
.ant-descriptions:not(.ant-descriptions-bordered) .ant-descriptions-item-label {
  /* The default for non-bordered description labels is too light - darken it a bit for readability */
  color: rgba(0, 0, 0, 0.65) !important;
}
.ant-descriptions.compact > .ant-descriptions-header {
  margin-bottom: 4px;
}
.ant-descriptions.compact > .ant-descriptions-header > .ant-descriptions-title {
  font-size: 14px;
}
.ant-collapse.compact .ant-collapse-header {
  padding: 4px 0 !important;
}
.ant-collapse.compact .ant-collapse-content-box {
  padding: 8px 0 16px 0 !important;
}
.compact .ant-table-cell {
  padding: 2px 8px !important;
}
.compact .ant-table-expanded-row > .ant-table-cell {
  padding: 8px !important;
}
.ant-table-wrapper .ant-table-cell * .ant-table-container:first-child {
  /* undo border 0 set by ant design styling for tables nested directly in a cell if we have anything in between.
     border colour should be synced to global border colour. */
  border-top: 1px solid rgba(0, 0, 0, 0.08);
}
.ontology-class {
  display: inline-block;
  padding: 0 2px;
  border-radius: 4px;
  transition: background-color 0.15s ease-in-out;
}
.ontology-class:hover {
  background-color: rgba(0, 0, 0, 0.04);
}
.ant-tooltip-inner a.iri-link {
  text-decoration: underline;
  color: var(--white-90);
}
.ant-tooltip-inner a.iri-link:hover {
  text-decoration: none;
  color: var(--white-80);
}
.ant-tooltip-inner a.iri-link:active {
  color: var(--white-70);
}
/* Persistent border — stays as long as the element should be highlighted */
.highlight-boundary {
  position: relative;
  border-radius: 10px;
}
/* The border itself lives on a pseudo-element so it can
   sit outside the element and respect border-radius */
.highlight-boundary::after {
  content: '';
  position: absolute;
  inset: -3px;
  /* expand outward by border width */
  border-radius: inherit;
  border: 3px solid rgba(22, 119, 255, 0.55);
  pointer-events: none;
}
/* Temporary pulse — added alongside highlight-boundary,
   removed after ~2.6s. Only adds animation to the
   already-existing ::after pseudo-element */
.highlight-animation::after {
  animation: highlightPulse 1s ease-out 0s 1;
}
@keyframes highlightPulse {
  0% {
    box-shadow: 0 0 0 0 color-mix(in srgb, var(--antd-blue-5) 35%, transparent);
  }
  70% {
    box-shadow: 0 0 0 14px color-mix(in srgb, var(--antd-blue-5) 0%, transparent);
  }
  100% {
    box-shadow: 0 0 0 0 color-mix(in srgb, var(--antd-blue-5) 0%, transparent);
  }
}
/* END phenopackets/other clinical+phenotypic metadata views */
@media (min-width: 1050px) and (max-width: 1550px) {
  .dataset-provenance-card-grid {
    /* This looks better at an intermediate screen width */
    grid-template-columns: repeat(auto-fit, minmax(350px, 0.5fr));
  }
}
@media (max-width: 768px) {
  /* Same breakpoint as constants/deviceBreakpoints DeviceBreakpoints.TABLET */
  :root {
    --content-padding-v: 10px;
    --content-padding-h: 10px;
    --content-scoped-title-margin-bottom: 10px;
  }
  .ant-layout-footer {
    padding: 24px;
  }
  .dataset-provenance-card-grid {
    --dataset-grid-gap: 8px;
  }
  .scoped-title__breadcrumb {
    font-size: 1.2rem;
    line-height: 46px;
  }
  .float-btn-pos {
    /* For small screens */
    bottom: 1.5em;
    right: 1em;
  }
  .ant-float-btn-group.float-btn-pos .ant-float-btn {
    scale: 100%;
  }
  :not(.ant-float-btn-group).float-btn-pos {
    scale: 100%;
  }
  .ant-float-btn-group.float-btn-pos {
    /* For small screens, reset group gap size */
    gap: 16px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles.css"],"names":[],"mappings":"AACA;EAAE,yCAAyC;EAEzC,qBAAA;EAEA,2BAAA;EACA,+BAAA;EAEA,yBAAA;EACA,yBAAA;EACA,2BAAA;EAEA,mCAAA;EACA,0CAAA;EAHA,sBAAsB;EAMtB,oCAAA;EAJA,sBAAsB;EAMtB,oCAAA;EAJA,sBAAsB;EAMtB,oCAAA;EAJA,sBAAsB;EAOtB,8BAAA;EAEA,sBAAA;AANF;AASA;EACE,aAAA;EACA,mBAAA;EACA,cAAA;EACA,6BAAA;EACA,gCAAA;EACA,mBAAA;EACA,iBAAA;AAPF;AAUA;;EAEE,gBAAA;EACA,yBAAA;EACA,SAAA;AARF;AACA,0BAA0B;AAa1B;EACE,wBAAA;AAXF;AACA,4CAA4C;AAc5C;EAAU,WAAA;AAXV;AAYA;EAAU,YAAA;AATV;AAUA;EAAU,YAAA;AAPV;AAQA;EAAO,SAAA;AALP;AAMA;;EAA8B,gBAAA;AAF9B;AAGA;EAAO,UAAA;AAAP;AACA;EAAU,OAAA;AAEV;AADA;EAAe,YAAA;AAIf;AAHA;EAAqB,kBAAA;AAMrB;AALA;EAAqB,kBAAA;AAQrB;AAPA;EAAS,cAAA;AAUT;AATA;EAAQ,aAAA;AAYR;AAXA;EAAc,kBAAA;AAcd;AACA,gDAAgD;AAdhD;EAAc,mBAAA;AAiBd;AAhBA;EAAkB,0BAAA;EAA4B,wBAAA;AAoB9C;AAnBA;EAAc,YAAA;AAsBd;AArBA;EAAa,qBAAA;AAwBb;AAvBA;EAAkB,eAAA;AA0BlB;AAzBA;EAAe,iBAAA;AA4Bf;AA3BA;EAAa,oCAAA;AA8Bb;AA7BA;EAAa,eAAA;AAgCb;AA/BA;EAAe,kBAAA;AAkCf;AAjCA;;EAA0B,+BAAA;AAqC1B;AApCA;EAAqB,6BAAA;AAuCrB;AAtCA;EAAU,kBAAA;AAyCV;AACA,2BAA2B;AAvC3B;EAAkB,6CAAA;AA0ClB;AAxCA;EACE,0CAAA;AA0CF;AAvCA;EAyCE,gCAAgC;EAvChC,WAAA;EACA,UAAA;AAyCF;AAvCA;EACE,WAAA;AAyCF;AAvCA;EAyCE,6DAA6D;EAvC7D,SAAA;AAyCF;AAvCA;EACE,WAAA;AAyCF;AACA,2BAA2B;AAtC3B;EACE,cAAA;AAwCF;AArCA;EACE,cAAA;EAuCA,8CAA8C;AAChD;AArCA;EAuCE;;;;;;;;;;;;;;;;;;;;;;;;GAwBC;EArCD,qBAAA;EACA,sBAAA;EACA,qBAAA;EACA,uBAAA;EACA,2BAAA;EACA,iCAAA;EACA,8BAAA;EACA,oBAAA;AAuCF;AACA,wBAAwB;AAlCxB;EACE,oBAAA;EACA,kBAAA;EAoCA,2CAA2C;EAnC3C,eAAA;AAqCF;AAlCA;EACE,yBAAA;AAoCF;AAjCA;EACE,yBAAA;AAmCF;AAhCA;EACE,cAAA;AAkCF;AA/BA;;EAEE,yBAAA;AAiCF;AA9BA;EACE,yBAAA;EACA,cAAA;AAgCF;AA5BA;EACE,2FAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,sBAAA;EA8BA,kEAAkE;EA3BlE,YAAA;EACA,UAAA;EACA,eAAA;EACA,gBAAA;AA6BF;AA3BA;EACE,gBAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;AA6BF;AAzBA;EACE,gBAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EAEA,sBAAA;EACA,0CAAA;EACA,wDAAA;EACA,gBAAA;EACA,gDAAA;EACA,iDAAA;EACA,mHAAA;EACA,oHAAA;EAEA,0CAAA;EACA,+CAAA;EAyBA,2CAA2C;EAxB3C,2BAAA;EAEA,mLAAA;AAyBF;AAjBA;EACE,UAAA;AAmBF;AAhBA;EACE,kBAAA;EAEA,iBAAA;EACA,0BAAA;AAiBF;AAdA;EACE,iBAAA;EACA,sCAAA;AAgBF;AAbA;EACE,gBAAA;AAeF;AAZA;EACE,YAAA;AAcF;AAXA;EACE,YAAA;EACA,gCAAA;EACA,yCAAA;AAaF;AAVA;EACE,UAAA;AAYF;AATA;EACE,WAAA;EACA,eAAA;EACA,YAAA;EAEA,iBAAA;AAUF;AAPA;EACE,iBAAA;EACA,iBAAA;AASF;AANA;EACE,YAAA;EACA,eAAA;EACA,iBAAA;AAQF;AACA,oCAAoC;AAHpC;EACE,cAAA;EACA,wBAAA;EACA,qBAAA;EACA,sBAAA;EACA,sBAAA;EACA,uBAAA;EACA,oBAAA;AAKF;AACA,kCAAkC;AAClC,8BAA8B;AAC9B;EACE,0CAAA;EACA,iBAAA;AACF;AACA;EACE,+CAAA;AACF;AAEA;EACE,eAAA;EACA,4BAAA;EACA,WAAA;EACA,YAAA;EACA,MAAA;EAAA;+BAC6B;EAG7B,eAAA;AADF;AAIA;EACE,SAAA;EACA,gBAAA;EACA,iCAAA;AAFF;AAIA;EACE,sBAAA;AAFF;AAIA;EACE,sBAAA;AAFF;AAKA;EACE,eAAA;EACA,OAAA;EACA,yBAAA;EACA,YAAA;EACA,+BAAA;EAEA,cAAA;EACA,0CAAA;EAEA,0BAAA;AALF;AAQA;EACE,gBAAA;EACA,wDAAA;AANF;AASA;EACE,+BAAA;AAPF;AAUA;EACE,eAAA;EACA,yBAAA;EACA,0BAAA;EACA,QAAA;EACA,SAAA;EAEA,cAAA;EACA,wCAAA;EACA,cAAA;EAEA,iCAAA;AAVF;AAaA;EACE,OAAA;EACA,WAAA;AAXF;AAcA;EACE,0DAAA;AAZF;AAeA;EACE,YAAA;AAbF;AAgBA;EACE,WAAA;EACA,mCAAA;AAdF;AACA,4BAA4B;AAkB5B;EACE,cAAA;AAhBF;AAmBA;EAjBE,2FAA2F;AAC7F;AAmBA;EAjBE,+FAA+F;EAmB/F,yBAAA;EACA,+BAAA;AAjBF;AACA,6BAA6B;AAC7B,4GAA4G;AAsB5G;EACE,aAAA;AApBF;AACA,8GAA8G;AAsB9G;EACE,gBAAA;AApBF;AACA,4DAA4D;AAuB5D;EACE,eAAA;EACA,YAAA;AArBF;AACA,2BAA2B;AAC3B,mBAAmB;AA2BnB;EACE,gBAAA;EACA,4HAAA;AAzBF;AA+BA;EACE,mBAAA;AA7BF;AA+BA;EACE,qBAAA;EA7BA,gDAAgD;AAClD;AA8BA;EACE,eAAA;EACA,YAAA;AA5BF;AA8BA;EACE,yCAAA;EACA,UAAA;AA5BF;AA8BA;EACE,0BAAA;EACA,mCAAA;AA5BF;AA8BA;;EAEE,cAAA;AA5BF;AA8BA;EACE,mBAAA;EACA,UAAA;EACA,4BAAA;EACA,6BAAA;EACA,oBAAA;AA5BF;AA+BA;EACE,mBAAA;AA7BF;AAgCA;EACE,kBAAA;EACA,OAAA;EACA,UAAA;EAEA,YAAA;EACA,WAAA;EAEA,kBAAA;EACA,eAAA;EAEA,mCAAA;AAjCF;AAmCA;EACE,cAAA;AAjCF;AAoCA;EACE,wBAAA;EAEA,aAAA;EAnCA,8BAA8B;EAqC9B,sHAAA;EACA,4BAAA;AAnCF;AAsCA;EACE,uBAAA;EApCA,yCAAyC;AAC3C;AAsCA;EACE,kCAAA;EApCA,8BAA8B;AAChC;AAsCA;EACE,oCAAA;AApCF;AAsCA;EACE,YAAA;AApCF;AACA,iBAAiB;AACjB,iBAAiB;AA0CjB;EACE,OAAA;AAxCF;AA2CA;EACE,iBAAA;EACA,aAAA;AAzCF;AA4CA;EACE,aAAA;EACA,uBAAA;EACA,WAAA;AA1CF;AA6CA;EACE,iBAAA;EACA,kBAAA;EACA,kBAAA;EA3CA,2CAA2C;EA6C3C,eAAA;EACA,yBAAA;EACA,uCAAA;EACA,yDAAA;EA3CA,cAAc;AAChB;AA6CA;EACE,qBAAA;AA3CF;AA8CA;EACE,yBAAA;AA5CF;AA+CA;EACE,4EAAA;AA7CF;AAgDA;EA9CE,wEAAwE;EAgDxE,gBAAA;AA9CF;AACA,eAAe;AACf,gEAAgE;AAmDhE;EAjDE,oDAAoD;EAmDpD,uBAAA;AAjDF;AAmDA;EAjDE,oDAAoD;EAmDpD,uBAAA;AAjDF;AAmDA;EAjDE,oDAAoD;EAmDpD,sBAAA;AAjDF;AAoDA;EACE,WAAA;AAlDF;AACA,sCAAsC;AAsDtC;EACE,mBAAA;AApDF;AAuDA;;EAEE,4BAAA;AArDF;AAuDA;EArDE,oEAAoE;EAuDpE,yBAAA;AArDF;AAwDA;EAtDE,mGAAmG;EAwDnG,qCAAA;AAtDF;AAyDA;EACE,kBAAA;AAvDF;AAyDA;EACE,eAAA;AAvDF;AA0DA;EACE,yBAAA;AAxDF;AA0DA;EACE,gCAAA;AAxDF;AA2DA;EACE,2BAAA;AAzDF;AA2DA;EACE,uBAAA;AAzDF;AA4DA;EA1DE;8DAC4D;EA4D5D,yCAAA;AA1DF;AA6DA;EACE,qBAAA;EACA,cAAA;EACA,kBAAA;EACA,8CAAA;AA3DF;AA6DA;EACE,qCAAA;AA3DF;AA8DA;EACE,0BAAA;EACA,sBAAA;AA5DF;AA8DA;EACE,qBAAA;EACA,sBAAA;AA5DF;AA8DA;EACE,sBAAA;AA5DF;AACA,2EAA2E;AA+D3E;EACE,kBAAA;EACA,mBAAA;AA7DF;AACA;sDACsD;AAgEtD;EACE,WAAA;EACA,kBAAA;EACA,WAAA;EA9DA,mCAAmC;EA+DnC,sBAAA;EACA,0CAAA;EACA,oBAAA;AA7DF;AACA;;4CAE4C;AAgE5C;EACE,0CAAA;AA9DF;AAiEA;EACE;IACE,2EAAA;EA/DF;EAiEA;IACE,6EAAA;EA/DF;EAiEA;IACE,0EAAA;EA/DF;AACF;AACA,8DAA8D;AAoE9D;EACE;IAlEE,sDAAsD;IAoEtD,6DAAA;EAlEF;AACF;AAqEA;EAnEE,4EAA4E;EAsE5E;IACE,yBAAA;IACA,yBAAA;IAEA,0CAAA;EArEF;EAwEA;IACE,aAAA;EAtEF;EAyEA;IACE,uBAAA;EAvEF;EA0EA;IACE,iBAAA;IACA,iBAAA;EAxEF;EA2EA;IAzEE,sBAAsB;IA2EtB,aAAA;IACA,UAAA;EAzEF;EA2EA;IACE,WAAA;EAzEF;EA2EA;IACE,WAAA;EAzEF;EA2EA;IAzEE,4CAA4C;IA2E5C,SAAA;EAzEF;AACF","sourcesContent":["\n:root {\n  /* sync with NAVBAR_HEIGHT in common.ts */\n  --header-height: 64px;\n\n  --sidebar-width-full: 200px;\n  --sidebar-width-collapsed: 80px;\n\n  --content-padding-v: 32px;\n  --content-padding-h: 64px;\n  --content-max-width: 1400px;\n\n  --content-scoped-title-height: 50px;\n  --content-scoped-title-margin-bottom: 24px;\n\n  /* 90% opacity white */\n  --white-90: rgba(255, 255, 255, 0.9);\n  /* 80% opacity white */\n  --white-80: rgba(255, 255, 255, 0.8);\n  /* 70% opacity white */\n  --white-70: rgba(255, 255, 255, 0.7);\n\n  /* 90% opacity black */\n  --black-90: rgba(0, 0, 0, 0.9);\n\n  --antd-blue-5: #1677ff;\n}\n\n.range-separator {\n  display: flex;\n  align-items: center;\n  padding: 0 8px;\n  border-top: 1px solid #d9d9d9;\n  border-bottom: 1px solid #d9d9d9;\n  background: #fafafa;\n  user-select: none;\n}\n\nhtml,\nbody {\n  min-height: 100%;\n  background-color: #f5f5f5;\n  margin: 0;\n}\n\n\n/* BEGIN utility classes */\n\n.no-margin-top {\n  margin-top: 0 !important;\n}\n\n/* Name compatible with tailwind if needed */\n.w-full { width: 100%; }\n.h-full { height: 100%; }\n.h-auto { height: auto; }\n.m-0 { margin: 0; }\n.mb-0, .ant-typography.mb-0 { margin-bottom: 0; }\n.p-0 { padding: 0; }\n.flex-1 { flex: 1; }\n.float-right { float: right; }\n.position-absolute { position: absolute; }\n.position-relative { position: relative; }\n.block { display: block; }\n.none { display: none; }\n.rounded-lg { border-radius: 8px; } /* also consistent with --ant-border-radius-lg */\n.rounded-xl { border-radius: 12px; }\n.rounded-e-none { border-start-end-radius: 0; border-end-end-radius: 0; }\n.opacity-50 { opacity: 0.50; }\n.list-none { list-style-type: none; }\n.cursor-pointer { cursor: pointer; }\n.select-none { user-select: none; }\n.font-mono { font-family: ui-monospace, monospace; }\n.text-base { font-size: 1rem; }\n.text-center { text-align: center; }\n.underline, a.underline { text-decoration-line: underline; }\n.decoration-dotted { text-decoration-style: dotted; }\n.italic { font-style: italic;}\n\n/* custom, tailwind-esque */\n.max-w-half-cmw { max-width: calc(var(--content-max-width) / 2); }\n\n.shadow {\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);\n}\n\n.float-btn-pos {\n  /* For normal computer screens */\n  bottom: 3em;\n  right: 5em;\n}\n:not(.ant-float-btn-group).float-btn-pos {\n  scale: 125%;\n}\n.ant-float-btn-group.float-btn-pos {\n  /* For normal screens, increase float button group gap size */\n  gap: 24px;\n}\n.ant-float-btn-group.float-btn-pos .ant-float-btn {\n  scale: 125%;\n}\n\n/* TODO: antd 6.x: gray-6 */\n.antd-gray-7 {\n  color: #8c8c8c;\n}\n\n.error-text {\n  color: #f5222d;  /* https://ant.design/docs/spec/colors red-6 */\n}\n\n.visually-hidden {\n  /*\n  For accessibility; visually hidden but available to screen readers. Taken from Bootstrap.\n\n  The MIT License (MIT)\n\n  Copyright (c) 2011-2026 The Bootstrap Authors\n\n  Permission is hereby granted, free of charge, to any person obtaining a copy\n  of this software and associated documentation files (the \"Software\"), to deal\n  in the Software without restriction, including without limitation the rights\n  to use, copy, modify, merge, publish, distribute, sublicense, and/or sell\n  copies of the Software, and to permit persons to whom the Software is\n  furnished to do so, subject to the following conditions:\n\n  The above copyright notice and this permission notice shall be included in\n  all copies or substantial portions of the Software.\n\n  THE SOFTWARE IS PROVIDED \"AS IS\", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR\n  IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,\n  FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE\n  AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER\n  LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,\n  OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN\n  THE SOFTWARE.\n  */\n  width: 1px !important;\n  height: 1px !important;\n  padding: 0 !important;\n  margin: -1px !important;\n  overflow: hidden !important;\n  clip: rect(0, 0, 0, 0) !important;\n  white-space: nowrap !important;\n  border: 0 !important;\n}\n\n/* END utility classes */\n\n\n.select-dataset-item {\n  transition: all 0.2s;\n  border-radius: 8px; /* Consistent with --ant-border-radius-lg */\n  cursor: pointer;\n}\n\n.select-dataset-item .ant-avatar {\n  background-color: #8c8c8c;\n}\n\n.select-dataset-item:hover {\n  background-color: #e6f4ff;\n}\n\n.select-dataset-item:hover .ant-avatar {\n  color: #e6f4ff;\n}\n\n.select-dataset-item.selected,\n.select-dataset-item.selected:hover {\n  background-color: #91caff;\n}\n\n.select-dataset-item.selected .ant-avatar {\n  background-color: #0958d9;\n  color: #91caff;\n}\n\n\n.ant-tag.filters-applied-tag {\n  transition: max-width 0.2s, padding 0.2s, border-width 0.2s, opacity 0.2s, margin-left 0.2s;\n  height: 22px;\n  vertical-align: top;\n  margin-top: 2px;\n  text-wrap: nowrap;\n  overflow: hidden;\n  box-sizing: border-box;\n\n  /* overridden by has-filters class when we have filters applied: */\n  max-width: 0;\n  padding: 0;\n  border-width: 0;\n  margin-left: 1px;\n}\n.ant-tag.filters-applied-tag.has-filters {\n  max-width: 150px;\n  padding: 0 7px;\n  border-width: 1px;\n  margin-left: 1em;\n}\n\n\n.scoped-title {\n  position: sticky;\n  top: -3px;\n  left: 0;\n  right: 0;\n  z-index: 20;\n\n  box-sizing: border-box;\n  height: var(--content-scoped-title-height);\n  margin-bottom: var(--content-scoped-title-margin-bottom);\n  padding-top: 3px;\n  margin-left: calc(-1 * var(--content-padding-h));\n  margin-right: calc(-1 * var(--content-padding-h));\n  padding-left: max(calc((100% - var(--content-max-width)) / 2 + var(--content-padding-h)), var(--content-padding-h));\n  padding-right: max(calc((100% - var(--content-max-width)) / 2 + var(--content-padding-h)), var(--content-padding-h));\n\n  background-color: rgba(245, 245, 245, 0.80);\n  border-bottom: 1px solid rgba(240, 240, 240, 0); /* invisible border to transition from/to */\n  backdrop-filter: blur(10px);\n\n  transition: border-bottom-color 0.5s ease-in-out,\n    margin 0.5s ease-in-out,\n    padding 0.5s ease-in-out,\n    height 0.5s ease-in-out,\n    box-shadow 0.1s ease-in-out,\n    opacity 0.5s ease-in-out;\n}\n\n.scoped-title .filters-applied-tag {\n  opacity: 0;\n}\n\n.scoped-title__back {\n  margin-right: 12px;\n\n  font-size: 1.8rem;\n  color: rgba(0, 0, 0, 0.45);\n}\n\n.scoped-title__breadcrumb {\n  font-size: 1.8rem;\n  transition: font-size 0.3s ease-in-out;\n}\n\n.scoped-title__breadcrumb .anticon {\n  font-size: 0.9em;\n}\n\n.scoped-title__breadcrumb .ant-breadcrumb-item a {\n  height: 3rem;\n}\n\n.scoped-title[data-stuck] {\n  height: 50px;\n  border-bottom: 1px solid rgba(235, 235, 235, 1);\n  box-shadow: 0 1px 5px rgba(0, 0, 0, 0.02);\n}\n\n.scoped-title[data-stuck] .filters-applied-tag {\n  opacity: 1;\n}\n\n.scoped-title[data-stuck] .scoped-title__back {\n  width: 32px;\n  min-width: 32px;\n  height: 32px;\n\n  font-size: 1.2rem;\n}\n\n.scoped-title[data-stuck] .scoped-title__breadcrumb {\n  font-size: 1.2rem;\n  line-height: 46px;\n}\n\n.scoped-title[data-stuck] .scoped-title__breadcrumb a {\n  height: 38px;\n  margin-top: 4px;\n  line-height: 38px;\n}\n\n\n/* BEGIN react18-json-view styling */\n\n.json-view {\n  color: #002b36;\n  --json-property: #002b36;\n  --json-index: #6c71c4;\n  --json-number: #268bd2;\n  --json-string: #cb4b16;\n  --json-boolean: #2aa198;\n  --json-null: #dc322f;\n}\n\n/* END react18-json-view styling */\n\n\n/* BEGIN layout HTML styling */\n\n#default-layout {\n  --sidebar-width: var(--sidebar-width-full);\n  min-height: 100vh;\n}\n#default-layout.sidebar-collapsed {\n  --sidebar-width: var(--sidebar-width-collapsed);\n}\n\n#site-header {\n  position: fixed;\n  height: var(--header-height);\n  width: 100%;\n  z-index: 100;\n  top: 0;\n\n  /* Header padding is reduced to 24px to provide more breathing room for buttons at small screen sizes and grid-align\n     logo with sidebar icons. */\n  padding: 0 24px;\n}\n\n#site-header h1.ant-typography {\n  margin: 0;\n  font-size: 1.5em;\n  line-height: var(--header-height);\n}\n#site-header.light h1.ant-typography {\n  color: var(--black-90);\n}\n#site-header.dark h1.ant-typography {\n  color: var(--white-90);\n}\n\n#site-sider {\n  position: fixed;\n  left: 0;\n  top: var(--header-height);\n  z-index: 100;\n  border-right: 1px solid #f0f0f0;\n\n  overflow: auto;\n  height: calc(100vh - var(--header-height));\n\n  transition: transform 0.3s;\n}\n\n#default-layout.sidebar-hidden #site-sider {\n  overflow: hidden;\n  transform: translate(calc(-1 * var(--sidebar-width)), 0);\n}\n\n.ant-layout-sider-trigger {\n  border-right: 1px solid #f0f0f0;\n}\n\n#content-layout {\n  position: fixed;\n  top: var(--header-height);\n  left: var(--sidebar-width);\n  right: 0;\n  bottom: 0;\n\n  display: block;\n  width: calc(100% - var(--sidebar-width));\n  overflow: auto;\n\n  transition: left 0.3s, width 0.3s;\n}\n\n#default-layout.sidebar-hidden #content-layout {\n  left: 0;\n  width: 100%;\n}\n\n#content-layout > .ant-layout-content {\n  padding: var(--content-padding-v) var(--content-padding-h);\n}\n\n.margin-auto {\n  margin: auto;\n}\n\n.container {\n  width: 100%;\n  max-width: var(--content-max-width);\n}\n\n/* END layout HTML styling */\n\n#dashboard-tabs {\n  margin: 0 12px;\n}\n\n#dashboard-tabs.ant-tabs-card > .ant-tabs-nav .ant-tabs-tab {\n  /* by default, antd card-style tab borders are too subtle. make them \"pop\" a bit more :-) */\n}\n#dashboard-tabs.ant-tabs-card > .ant-tabs-nav .ant-tabs-tab:not(.ant-tabs-tab-active) {\n  /* by default, antd card-style unselected tabs are too subtle. make them \"pop\" a bit more :-) */\n  border: 1px solid #e9e9e9;\n  background: rgba(0, 0, 0, 0.03);\n}\n\n\n/* BEGIN about HTML styling */\n\n/* Elements which are the first child of the about content container shouldn't have the default top margin */\n.about-content *:first-child {\n  margin-top: 0;\n}\n/* Elements which are the last child of the about content container shouldn't have the default bottom margin */\n.about-content *:last-child {\n  margin-bottom: 0;\n}\n\n/* Images should scale proportionally with container width */\n.about-content img {\n  max-width: 100%;\n  height: auto;\n}\n\n/* END about HTML styling */\n\n\n/* BEGIN overview */\n\n.count-card {\n  min-width: 150px;\n  transition:\n    height 0.3s ease-in-out,\n    margin-bottom 0.3s ease-in-out,\n    box-shadow 0.15s ease-in-out,\n    opacity 0.15s ease-in-out;\n}\n.count-card .ant-statistic .ant-statistic-content {\n  white-space: nowrap;\n}\n.count-card.shadow {\n  border-color: #e9e9e9; /* a bit darker to contrast against box-shadow */\n}\n.count-card.shadow.count-card-clickable {\n  cursor: pointer;\n  opacity: 0.9;\n}\n.count-card.shadow.count-card-clickable:hover {\n  box-shadow: 0 3px 15px rgba(0, 0, 0, 0.1);\n  opacity: 1;\n}\n.count-card.shadow.count-card-clickable .counts-title {\n  text-decoration: underline;\n  transition: color 0.15s ease-in-out;\n}\n.count-card.shadow.count-card-clickable:hover .counts-title,\n.count-card.shadow.count-card-clickable:hover .count-card__show-hide {\n  color: #1677ff;\n}\n.count-card.shadow.count-card-selected {\n  border-bottom: none;\n  z-index: 3;\n  border-bottom-left-radius: 0;\n  border-bottom-right-radius: 0;\n  margin-bottom: -12px;\n}\n\n.counts-title__text {\n  white-space: nowrap;\n}\n\n.count-card__show-hide {\n  position: absolute;\n  left: 0;\n  z-index: 4;\n\n  height: 32px;\n  width: 100%;\n\n  text-align: center;\n  font-size: 12px;\n\n  transition: bottom 0.3s ease-in-out;\n}\n.count-card__show-hide:hover {\n  color: #1677ff;\n}\n\n.dataset-provenance-card-grid {\n  --dataset-grid-gap: 20px;\n\n  display: grid;\n  /* 690 * 2 + 20 (gap) = 1400 */\n  grid-template-columns: repeat(auto-fit, minmax(250px, calc((var(--content-max-width) - var(--dataset-grid-gap)) / 2)));\n  gap: var(--dataset-grid-gap);\n}\n\n.slick-arrow {\n  color: black !important; /* override slick-next/slick-prev color */\n}\n\n.slick-dots li button {\n  background-color: black !important; /* override slick-dots color */\n}\n\n.overview {\n  transition: opacity 0.2s ease-in-out;\n}\n.overview.loading {\n  opacity: 0.2;\n}\n\n/* END overview */\n\n\n/* BEGIN search */\n\n.search-sub-form {\n  flex: 1;\n}\n\nh3.search-sub-form-title {\n  font-size: 1.1rem;\n  margin-top: 0;\n}\n\n.search-results-pane {\n  display: flex;\n  justify-content: center;\n  width: 100%;\n}\n\n.search-result-statistic.enabled {\n  padding: 8px 16px;\n  margin-left: -16px;\n  border-radius: 8px; /* Consistent with --ant-border-radius-lg */\n\n  cursor: pointer;\n  border: 1px solid #d9d9d9;\n  box-shadow: 0 2px 0 rgba(0, 0, 0, 0.02);\n  transition: all 0.2s cubic-bezier(0.645, 0.045, 0.355, 1); /* from antd */\n}\n\n.search-result-statistic.enabled:hover {\n  border-color: #4096ff;\n}\n\n.search-result-statistic.selected {\n  background-color: #fafafa;\n}\n\n.search-result-statistic.enabled.selected {\n  box-shadow: 0 2px 0 rgba(0, 0, 0, 0.02), inset 0 2px 5px rgba(0, 0, 0, 0.08);\n}\n\n.ant-table-wrapper .ant-table.ant-table-empty .ant-table-tbody > tr.ant-table-placeholder {\n  /* patch for ant background clip issue in empty tables with no headers */\n  background: none;\n}\n\n/* END search */\n\n/* BEGIN phenopackets/other clinical+phenotypic metadata views */\n\n.fixed-item-label-width .ant-descriptions-item-label {\n  /* Align split line vertically in all descriptions */\n  width: min(30vw, 250px);\n}\n.fixed-item-label-width-narrow .ant-descriptions-item-label {\n  /* Align split line vertically in all descriptions */\n  width: min(15vw, 125px);\n}\n.fixed-item-label-width-very-narrow .ant-descriptions-item-label {\n  /* Align split line vertically in all descriptions */\n  width: min(15vw, 80px);\n}\n\ntr.ant-table-expanded-row .ant-descriptions-item-content .ant-descriptions > .ant-descriptions-view > table {\n  width: auto;\n}\n\n/*  - compact descriptions and table */\n\n.ant-descriptions.compact .ant-descriptions-row > td {\n  padding-bottom: 2px;\n}\n\n.ant-descriptions.compact .ant-descriptions-item-content,\n.ant-descriptions.compact .ant-descriptions-item-label {\n  padding: 2px 12px !important;\n}\n.ant-descriptions-item-content .ant-descriptions.compact:not(.ant-descriptions-bordered) .ant-descriptions-item-label {\n  /* nested non-bordered description items - kill horizontal padding */\n  padding: 2px 0 !important;\n}\n\n.ant-descriptions:not(.ant-descriptions-bordered) .ant-descriptions-item-label {\n  /* The default for non-bordered description labels is too light - darken it a bit for readability */\n  color: rgba(0, 0, 0, 0.65) !important;\n}\n\n.ant-descriptions.compact > .ant-descriptions-header {\n  margin-bottom: 4px;\n}\n.ant-descriptions.compact > .ant-descriptions-header > .ant-descriptions-title {\n  font-size: 14px;\n}\n\n.ant-collapse.compact .ant-collapse-header {\n  padding: 4px 0 !important;\n}\n.ant-collapse.compact .ant-collapse-content-box {\n  padding: 8px 0 16px 0 !important;\n}\n\n.compact .ant-table-cell {\n  padding: 2px 8px !important;\n}\n.compact .ant-table-expanded-row > .ant-table-cell {\n  padding: 8px !important;\n}\n\n.ant-table-wrapper .ant-table-cell * .ant-table-container:first-child {\n  /* undo border 0 set by ant design styling for tables nested directly in a cell if we have anything in between.\n     border colour should be synced to global border colour. */\n  border-top: 1px solid rgba(0, 0, 0, 0.08);\n}\n\n.ontology-class {\n  display: inline-block;\n  padding: 0 2px;\n  border-radius: 4px;\n  transition: background-color 0.15s ease-in-out;\n}\n.ontology-class:hover {\n  background-color: rgba(0, 0, 0, 0.04);\n}\n\n.ant-tooltip-inner a.iri-link {\n  text-decoration: underline;\n  color: var(--white-90);\n}\n.ant-tooltip-inner a.iri-link:hover {\n  text-decoration: none;\n  color: var(--white-80);\n}\n.ant-tooltip-inner a.iri-link:active {\n  color: var(--white-70);\n}\n\n/* Persistent border — stays as long as the element should be highlighted */\n.highlight-boundary {\n  position: relative;\n  border-radius: 10px;\n}\n\n/* The border itself lives on a pseudo-element so it can\n   sit outside the element and respect border-radius */\n.highlight-boundary::after {\n  content: '';\n  position: absolute;\n  inset: -3px; /* expand outward by border width */\n  border-radius: inherit;\n  border: 3px solid rgba(22, 119, 255, 0.55);\n  pointer-events: none;\n}\n\n/* Temporary pulse — added alongside highlight-boundary,\n   removed after ~2.6s. Only adds animation to the\n   already-existing ::after pseudo-element */\n.highlight-animation::after {\n  animation: highlightPulse 1s ease-out 0s 1;\n}\n\n@keyframes highlightPulse {\n  0% {\n    box-shadow: 0 0 0 0 color-mix(in srgb, var(--antd-blue-5) 35%, transparent);\n  }\n  70% {\n    box-shadow: 0 0 0 14px color-mix(in srgb, var(--antd-blue-5) 0%, transparent);\n  }\n  100% {\n    box-shadow: 0 0 0 0 color-mix(in srgb, var(--antd-blue-5) 0%, transparent);\n  }\n}\n\n/* END phenopackets/other clinical+phenotypic metadata views */\n\n\n@media (min-width: 1050px) and (max-width: 1550px) {\n  .dataset-provenance-card-grid {\n    /* This looks better at an intermediate screen width */\n    grid-template-columns: repeat(auto-fit, minmax(350px, 0.5fr));\n  }\n}\n\n@media (max-width: 768px) {\n  /* Same breakpoint as constants/deviceBreakpoints DeviceBreakpoints.TABLET */\n\n  :root {\n    --content-padding-v: 10px;\n    --content-padding-h: 10px;\n\n    --content-scoped-title-margin-bottom: 10px;\n  }\n\n  .ant-layout-footer {\n    padding: 24px;\n  }\n\n  .dataset-provenance-card-grid {\n    --dataset-grid-gap: 8px;\n  }\n\n  .scoped-title__breadcrumb {\n    font-size: 1.2rem;\n    line-height: 46px;\n  }\n\n  .float-btn-pos {\n    /* For small screens */\n    bottom: 1.5em;\n    right: 1em;\n  }\n  .ant-float-btn-group.float-btn-pos .ant-float-btn {\n    scale: 100%;\n  }\n  :not(.ant-float-btn-group).float-btn-pos {\n    scale: 100%;\n  }\n  .ant-float-btn-group.float-btn-pos {\n    /* For small screens, reset group gap size */\n    gap: 16px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
